import LegalLayout from "./LegalLayout";

export default function Terms() {
  const sections = [
    { t: "1. Acceptance", b: "By using PerCen360.com you agree to these Terms." },
    { t: "2. Service", b: "PerCen360 provides expense management, grant tracking, VAT3/CRO reporting, and compliance tools. It is provided \u201cas is\u201d." },
    { t: "3. User Obligations", b: (
      <ul className="list-disc pl-6 space-y-1">
        <li>Provide accurate information</li>
        <li>Use only for lawful purposes</li>
        <li>Maintain the security of your account</li>
      </ul>
    )},
    { t: "4. Intellectual Property", b: "All platform code and design belong to PerCen Technologies Ltd. You retain ownership of your uploaded data." },
    { t: "5. No Professional Advice", b: "PerCen360 is a support tool only. It is not financial, legal, or tax advice. You are solely responsible for your compliance and decisions." },
    { t: "6. Limitation of Liability", b: "To the maximum extent permitted by law, PerCen Technologies Ltd and Gillian Berry accept no liability for any loss, damage, or inaccuracy arising from use of the platform. We do not guarantee uninterrupted service or 100% accuracy of reports." },
    { t: "7. Termination", b: "We may suspend or terminate access for breach. You may cancel your subscription anytime." },
    { t: "8. Governing Law", b: "Irish law. Disputes subject to Irish courts." },
    { t: "9. Changes", b: "We may update these Terms. Continued use constitutes acceptance." },
  ];

  return (
    <LegalLayout eyebrow="Legal · Terms" title="Terms and Conditions" effective="PerCen360.com – PerCen Technologies Ltd">
      {sections.map((s) => (
        <section key={s.t}>
          <h2 className="font-display text-xl mb-2">{s.t}</h2>
          {typeof s.b === "string" ? <p>{s.b}</p> : s.b}
        </section>
      ))}
      <section>
        <p className="text-sm text-white/60">Contact: <a className="text-[#FFB020] underline" href="mailto:gillian@percen360.com">gillian@percen360.com</a></p>
      </section>
    </LegalLayout>
  );
}
